export enum ChartType {
    datatable = 0,
    doughnut,
    bar,
    horizontalBar,
    line,
    radar,
    sunburst
}
